import moment from "moment";
import { LoadState } from "../../../constants/enums";
import { getUniqueId } from "../../../helpers";

export interface IBillPaymentPayableState {
  data: ISingleBillPayment;
  loading: LoadState;
  list: IBillPaymentRecord[];
  listLoading: LoadState;
  error: any;
}

export interface IBillPaymentDetails {
  key: string;
  date: string;
  bill_number: string;
  bill_amount: string;
  amount_due: string;
  payment_paid: string;
  amount_paid: string;
  fromVendor: boolean;
}

export interface IBillPaymentRecord {
  accn_create_payment_id?: string | null;
  vendor_type: string | null;
  create_payment_code: string | null;
  customer_id: string | null;
  customer_policy_id: string | null;
  policy_number: string | null;
  gl_account: string | null;
  invoice_payment_gl_account_name: string | null;
  payment_id: string | null;
  vendor: string | null;
  name: string | null;
  payment_made: string;
  bank_charges: string | null;
  payment_method: string | null;
  payment_date: string | null;
  cheque_id: string | null;
  paid_through_account: string | null;
  reference_id: string | null;
  total_amount: string;
  amount_paid: string;
  amount_used_for_payments: string;
  amount_refunded: string;
  amount_in_excess: string;
  notes: string;
  status: string;
  amount_due: string;
  paid_to: string | null;
  paid_to_type: string | null;
  paid_to_name: string | null;
  bill_payment_type: string | null;
  reconciled?: string | null;
  reconciled_date?: string | null;
}
export interface ISingleBillPayment extends IBillPaymentRecord {
  bill_payment_details: IBillPaymentDetails[];
}

export const initialBillPaymentPayableState: IBillPaymentPayableState = {
  list: [],
  listLoading: LoadState.NotLoaded,
  data: {
    vendor_type: null,
    create_payment_code: null,
    customer_id: null,
    customer_policy_id: null,
    payment_id: null,
    vendor: null,
    name: null,
    paid_to_type: null,
    paid_to_name: null,
    gl_account: "",
    policy_number: null,
    invoice_payment_gl_account_name: "",
    payment_made: "",
    payment_date: moment().format("YYYY-MM-DD"),
    cheque_id: "",
    bank_charges: null,
    payment_method: null,
    paid_through_account: null,
    reference_id: null,
    bill_payment_details: [
      {
        key: getUniqueId(),
        date: "",
        amount_due: "",
        bill_amount: "",
        bill_number: "",
        amount_paid: "",
        payment_paid: "",
        fromVendor: false,
      },
    ],
    total_amount: "",
    amount_paid: "0",
    amount_used_for_payments: "",
    amount_refunded: "",
    amount_in_excess: "",
    notes: "",
    status: "ACTIVE",
    amount_due: "0",
    bill_payment_type: null,
    paid_to: null,
  },
  loading: LoadState.NotLoaded,
  error: null,
};
